import {
  emailRegex,
  englishRegex,
  iranMobileRegex,
  persianLetterRegex
} from '../../helpers/regex'
import { ConfirmPrimitiveReservationInput } from '../../types/cart'
import { validateIdentificationNo } from './components/helpers/helper'

export function validateConfirmPrimitiveInput(
  input: ConfirmPrimitiveReservationInput,
  optionReservationExpiry: boolean
): boolean {
  const { booker, confirmRooms } = input

  if (optionReservationExpiry) {
    return !!input.expiresAt
  }

  // --- Booker validation ---
  const isBookerValid =
    !!booker.firstName &&
    (booker.isForeigner
      ? englishRegex.test(booker.firstName)
      : persianLetterRegex.test(booker.firstName)) &&
    !!booker.lastName &&
    (booker.isForeigner
      ? englishRegex.test(booker.lastName)
      : persianLetterRegex.test(booker.lastName)) &&
    !!booker.email &&
    emailRegex.test(booker.email) &&
    !!booker.identificationNo &&
    validateIdentificationNo(booker.identificationNo, booker.isForeigner) &&
    !!booker.mobile &&
    iranMobileRegex.test(booker.mobile)

  if (!isBookerValid) {
    return false
  }

  // --- Confirm rooms validation ---
  for (let rIndex = 0; rIndex < confirmRooms.length; rIndex++) {
    const room = confirmRooms[rIndex]
    if (!room.profiles || room.profiles.length === 0) {
      return false
    }

    for (let pIndex = 0; pIndex < room.profiles.length; pIndex++) {
      const profile = room.profiles[pIndex]
      const isProfileValid =
        !!profile.firstName &&
        (profile.isForeigner
          ? englishRegex.test(profile.firstName)
          : persianLetterRegex.test(profile.firstName)) &&
        !!profile.lastName &&
        (profile.isForeigner
          ? englishRegex.test(profile.lastName)
          : persianLetterRegex.test(profile.lastName)) &&
        !!profile.email &&
        emailRegex.test(profile.email) &&
        !!profile.identificationNo &&
        validateIdentificationNo(
          profile.identificationNo,
          profile.isForeigner
        ) &&
        !!profile.mobile &&
        iranMobileRegex.test(profile.mobile)

      if (!isProfileValid) {
        return false
      }
    }
  }

  return true
}
